import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';

// ------------------------------
// Initial State
// ------------------------------
const initState = {
  users: null,
  loading: false,
  total: 0,
  filters: null,
  filteredTotal: 0,
};

// ------------------------------
// Action Handlers
// ------------------------------
function onLoad(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal, filters } = payload;
  const users = data;

  return {
    ...state,
    users,
    total,
    filters,
    filteredTotal,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

// ------------------------------
// Local util functions
// ------------------------------

// ------------------------------
// Exported reducer function.
// ------------------------------
export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
